import { TEXTS } from 'application/pages/PointsPage/renderer/texts';
import React from 'react';
import CollapsibleSection from '../CollapsibleSection';
import { CUT_MUSIC_EXAMPLE_IMAGES } from './consts';
import styles from './index.module.scss';

const HelpModalContent = () => (
  <div className={styles.inner}>
    <div
      className={styles.text}
      data-testid="cut_music_help_intro">
      {TEXTS.CUT_MUSIC_HELP_MODAL_INTRO}
    </div>

    <ul
      className={styles.list}
      data-testid="cut_music_help_list">
      <li className={styles.listItem}>{TEXTS.CUT_MUSIC_HELP_MODAL_BULLET_0SEC}</li>
      <li className={styles.listItem}>{TEXTS.CUT_MUSIC_HELP_MODAL_BULLET_30_60SEC}</li>
    </ul>

    <div
      className={styles.sectionTitle}
      data-testid="cut_music_help_overlap_title">
      {TEXTS.CUT_MUSIC_HELP_MODAL_OVERLAP_SECTION}
    </div>

    <div
      className={styles.block}
      data-testid="cut_music_help_shift_block">
      <div
        className={styles.blockTitle}
        data-testid="cut_music_help_shift_title">
        {TEXTS.CUT_MUSIC_HELP_MODAL_SHIFT_TITLE}
      </div>
      <div
        className={styles.blockDesc}
        data-testid="cut_music_help_shift_description">
        {TEXTS.CUT_MUSIC_HELP_MODAL_SHIFT_DESC}
      </div>
      <img
        className={styles.image}
        data-testid="cut_music_help_shift_image"
        alt=""
        src={CUT_MUSIC_EXAMPLE_IMAGES.SHIFT}
      />
    </div>

    <div
      className={styles.block}
      data-testid="cut_music_help_drop_block">
      <div
        className={styles.blockTitle}
        data-testid="cut_music_help_drop_title">
        {TEXTS.CUT_MUSIC_HELP_MODAL_DROP_TITLE}
      </div>
      <div
        className={styles.blockDesc}
        data-testid="cut_music_help_drop_description">
        {TEXTS.CUT_MUSIC_HELP_MODAL_DROP_DESC}
      </div>
      <img
        className={styles.image}
        data-testid="cut_music_help_drop_image"
        alt=""
        src={CUT_MUSIC_EXAMPLE_IMAGES.DROP}
      />
    </div>

    <CollapsibleSection title={TEXTS.CUT_MUSIC_HELP_MODAL_EXAMPLE_TITLE}>
      <div
        className={styles.exampleContent}
        data-testid="cut_music_help_example_content">
        <div
          className={styles.blockDesc}
          data-testid="cut_music_help_example_description">
          {TEXTS.CUT_MUSIC_HELP_MODAL_EXAMPLE_DESC}
        </div>
        <img
          className={styles.image}
          data-testid="cut_music_help_example_0_image"
          alt=""
          src={CUT_MUSIC_EXAMPLE_IMAGES.EXAMPLE_0SEC}
        />
        <img
          className={styles.image}
          data-testid="cut_music_help_example_30_image"
          alt=""
          src={CUT_MUSIC_EXAMPLE_IMAGES.EXAMPLE_30SEC}
        />
        <img
          className={styles.image}
          data-testid="cut_music_help_example_60_image"
          alt=""
          src={CUT_MUSIC_EXAMPLE_IMAGES.EXAMPLE_60SEC}
        />
      </div>
    </CollapsibleSection>
  </div>
);

export default HelpModalContent;
